<template>
  <div class="wrapper">
    <div class="header-section">
      <h5>Regulamin</h5>
    </div>
    <div class="text-section">
      <p>
        Niniejszy Regulamin określa warunki prowadzenia sprzedaży za pośrednictwem
        sklepu internetowego splendorwrld.com zwanego dalej „Sklepem” a osobą fizyczną zwanej dalej “Klientem”.
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §I. Postanowienia ogólne:
      </h5>
    </div>
    <div class="text-section">
      <p>
        Sklep prowadzi sprzedaż towarów za pośrednictwem sieci Internet.
        Informacje na temat swojej oferty Sklep zamieszcza na stronie splendorwrld.com.
        Tam również znajduje się zakładka „Kontakt”, w której podane są informacje identyfikacyjne firmy,
        która prowadzi sklep, adres przedsiębiorstwa, adres poczty elektronicznej oraz numery telefonów,
        za pomocą których Klient może komunikować się ze Sklepem.
        Sklep internetowy prowadzony jest w ramach spółki z ograniczoną odpowiedzialnością,
        zarejestrowanej pod firmą SPLENDOR WRLD SP. Z O.O.” z siedzibą w Warszawie przy ulicy Jana Kazimierza 57/46
        (NIP: 5273011821, REGON:522645678).
      </p>
      <p>
        Do korzystania z usług Sklepu niezbędny jest dostęp do Internetu,
        konto poczty elektronicznej oraz numer telefonu. Konto poczty elektronicznej oraz numer telefonu
        muszą być własnością Klienta rejestrującego się w Sklepie.
        W celu prawidłowego funkcjonowania serwisu, komputer użytkownika musi obsługiwać pliki typu „cookie”.
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §2. Zakupy w Sklepie.
      </h5>
    </div>
    <div class="text-section">
      <p>
        Przy każdym produkcie jest określona jego cena wraz z podatkiem VAT i liczba dostępności
        towaru w sklepie. Do każdego zamówienia wystawiany jest paragon imienny lub faktura VAT.
        Faktura VAT wystawiana jest w chwili, gdy wszystkie towary wybrane do zamówienia są
        skompletowane i gotowe do wysyłki, na kwotę łączną wszystkich kosztów umówionych z Klientem.
        Faktura ta stanowi dokument umowy zawartej na odległość
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §3. Warunki płatności.
      </h5>
    </div>
    <div class="text-section">
      <p>
        Obowiązującymi cenami za zamówione towary są ceny opublikowane na stronie Sklepu.
        Możliwe są następujące formy płatności za zamówiony towar: <br>
        - płatność za pobraniem: gotówką kurierowi lub na poczcie przy odbiorze towaru; <br>
        - przelewem bankowym: zamówienie zostanie zrealizowane z chwilą wpłynięcia środków na rachunek bankowy Sklepu; <br>
      </p>
      <p>
        Podmiotem świadczącym obsługę płatności online jest Paynow.
        W przypadku wystąpienia konieczność zwrotu środków za transakcję dokonaną przez klienta kartą płatniczą,
        sprzedający dokona zwrotu na rachunek bankowy przypisany do karty płatniczej Zamawiającego.
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §4. Terminy i warunki realizacji zamówienia.
      </h5>
    </div>
    <div class="text-section">
      <p>
        Zamówienia realizowane są w dni robocze od poniedziałku do piątku.
        Termin dostawy zamówionego towaru uzależniony jest od ilości dni roboczych jakie potrzebne
        są od momentu potwierdzenia realizacji zamówienia do chwili skompletowania zamówionego towaru,
        przygotowania go do wysyłki oraz czas jaki potrzebny jest na dostarczenie towaru do zamawiającego.
        W przypadku sprzedaży wysyłkowej termin realizacji wynosi zazwyczaj około 3 dni roboczych licząc od
        dnia wysłania przez Sklep informacji o potwierdzeniu przyjęcia zamówienia do realizacji z
        zastrzeżeniem pkt 4. Zamówienia złożone do godziny 12:00 każdego dnia roboczego realizowane są
        tego samego dnia z zastrzeżeniem pkt 4 i dotyczy to produktów dostępnych w danej chwili w sklepie.
        Jeżeli strony nie ustaliły innego terminu i czasu dostawy przyjmuje się, iż terminowa dostawa zamówionego
        towaru nie powinna nastąpić później niż w ciągu 30 dni roboczych licząc od dnia przyjęcia zamówienia
        do realizacji. W przypadku wystąpienia ewentualnych przeszkód w terminowej realizacji zlecenia,
        Klient zostanie poinformowany o tym fakcie oraz o możliwościach zmiany lub anulacji zlecenia,
        nie później niż w terminie 30 dni od dnia zawarcia umowy. W przypadku towarów oznaczonych „Na zamówienie”
        czas oczekiwania na realizację zamówienia jest ustalany z Klientem indywidualnie i uzależniony jest od
        dostępności określonych towarów w Sklepie o czym klient jest informowany przed zawarciem umowy.
        Koszt dostawy uzależniony jest od wagi, wymiarów produktu oraz sposobu dostawy zamawianego produktu,
        który zostanie wybrany przez Klienta. Koszt dostawy jest ustalany każdorazowo w procesie składania zamówienia.
        Sklep zobowiązuje się dostarczyć produkt bez wad. Jeżeli dana rzecz, wystawiona przez Sklep na sprzedaż,
        objęta jest gwarancją, będzie ona określona wraz z zasadami jej realizacji w opisie danej rzeczy, na jej podstronie.
        W przypadku wyboru przez klienta sposobu płatności przelewem lub kartą płatniczą, czas realizacji zamówienia
        liczony jest od dnia uznania rachunku bankowego lub konta rozliczeniowego Sprzedawcy.
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §5. Odstąpienie od umowy
      </h5>
    </div>
    <div class="text-section">
      <p>
        Klient ma prawo odstąpić od niniejszej umowy w terminie 14 dni bez podania jakiejkolwiek przyczyny i bez ponoszenia kosztów. Jednakże jeżeli Klient wybrał sposób dostarczenia produktów inny niż najtańszy zwykły sposób dostarczenia oferowany przez Sklep, Sklep nie jest zobowiązany do zwrotu Klientowi poniesionych przez niego dodatkowych kosztów.Aby skorzystać z prawa odstąpienia od umowy, Klient musi poinformować Sklep o swojej decyzji o odstąpieniu od niniejszej umowy w drodze jednoznacznego oświadczenia (na przykład pismo wysłane pocztą, faksem lub pocztą elektroniczną) i najpóźniej do 14 dni od dnia odebrania produktów odesłać je.Klient może skorzystać z wzoru formularza odstąpienia od umowy, jednak nie jest to obowiązkowe. Wzór formularza znajduje się pod regulaminem.Klient nie posiada prawa odstąpienia od umowy w przypadku umów: <br> <br>
        a) w której przedmiotem jest produkt nieprefabrykowany, wyprodukowany według specyfikacji Klienta lub służący zaspokojeniu jego zindywidualizowanych potrzeb, <br>

        b) w której przedmiotem jest produkt ulegający szybkiemu zepsuciu lub mający krótki termin przydatności do użycia, <br>

        c) w której przedmiotem świadczenia jest produkt dostarczany w zapieczętowanym opakowaniu, którego po otwarciu opakowania nie można zwrócić ze względu na ochronę zdrowia lub ze względów higienicznych, jeżeli opakowanie zostało otwarte po dostarczeniu, <br>

        d) w której przedmiotem świadczenia są rzeczy, które po dostarczeniu, ze względu na swój charakter, zostają nierozłącznie połączone z innymi rzeczami, <br>

        e) w której Klient wyraźnie żądał, aby przedstawiciel Sklepu do niego przyjechał w celu dokonania pilnej naprawy lub konserwacji; jeżeli Sklep świadczy dodatkowo inne usługi niż te, których wykonania Klient żądał, lub dostarcza produkty inne niż części zamienne niezbędne do wykonania naprawy lub konserwacji, prawo odstąpienia od umowy przysługuje Klientowi w odniesieniu do dodatkowych usług lub rzeczy; <br>
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        Skutki odstąpienia od umowy
      </h5>
    </div>
    <div class="text-section">
      <p>
        W przypadku odstąpienia od niniejszej umowy Sklep zwraca Klientowi wszystkie otrzymane od Klienta płatności, w tym koszty dostarczenia produkty (z wyjątkiem dodatkowych kosztów wynikających z wybranego przez Klienta sposobu dostarczenia innego niż najtańszy zwykły sposób dostarczenia oferowany przez Sklep), niezwłocznie, a w każdym przypadku nie później niż 14 dni od dnia, w którym Sklep zostanie poinformowany o Klienta decyzji o wykonaniu prawa odstąpienia od niniejszej umowy. Zwrotu płatności Sklep dokonuje przy użyciu takich samych sposobów płatności, jakie zostały przez Klienta użyte w pierwotnej transakcji, chyba że Klient wyraźnie zgodzi się na inne rozwiązanie. W każdym przypadku nie ponosi Klient żadnych opłat w związku z tym zwrotem.
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §6. Ochrona danych osobowych
      </h5>
    </div>
    <div class="text-section">
      <p>
        Dane osobowe będą przetwarzane w celu korzystania z usług świadczonych przez SPLENDOR WRLD SP. Z O.O. Podstawą prawną przetwarzania danych osobowych jest umowa - art. 6 ust. 1 lit. b) Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679a z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), zwanego dalej RODO. Podstawą prawną przetwarzania danych osobowych jest również prawnie uzasadniony interes administratora danych - art. 6 ust. 1 lit. f) RODO, polegający realizacji celów marketingowych, poprzez promocję własnych produktów i usług. Prawnie uzasadnionym interesem administratora danych jest również zabezpieczenie SPLENDOR WRLD SP. Z O.O.” przed ewentualnymi roszczeniami.
      </p>
    </div>

    <div class="subtitle-section">
      <h5>
        §7. Postanowienia końcowe
      </h5>
    </div>
    <div class="text-section">
      <p>
        W sprawach nieuregulowanych w niniejszym Regulaminie mają zastosowanie przepisy Kodeksu Cywilnego (Dz.U. 2014 poz. 121) oraz przepisy Ustawy o prawie Konsumenta (Dz.U. 2014 poz. 827).
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Rules'
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  width: 100%;
  padding: 10px;
  padding-top: 80px;
  color: #000000;
}
.header-section {
  margin-bottom: 20px;
  letter-spacing: 3px;
  font-weight: bold;
}

.subtitle-section {
  margin-bottom: 10px;
  letter-spacing: 2px;
  font-weight: bold;
}

.text-section {
  text-align: justify;
}
.image-section {
  margin-bottom: 100px;
  margin-top: 50px;
}
.image-section img {
  width: 100%;
}

@media (min-width: 992px) {
  .wrapper {
    padding-top: 100px;
    width: 96%;
    margin-right: auto;
    margin-left: auto;
  }
  .text-section {
    font-size: 1.2rem;
    letter-spacing: 1.5px;
  }
  .header-section {
    margin-bottom: 80px;
    letter-spacing: 4px;
  }
  .header-section h5 {
    font-size: 2rem;
    font-weight: bold;
  }
  .subtitle-section {
    margin-bottom: 20px;
    letter-spacing: 2px;
  }
  .subtitle-section h5 {
    font-size: 1.4rem;
    text-align: left;
    font-weight: bold;
  }
  .image-section {
    margin-top: 90px;
    margin-bottom: 140px;
  }
}
</style>
